<script setup lang="ts">
import BreezyLogo from "./BreezyLogo.vue";

const { withFooter = true } = defineProps<{ withFooter?: boolean }>();
</script>

<template>
    <section class="step">
        <header v-if="$slots.header" class="step__header">
            <slot name="header" />
        </header>
        <div class="step__content">
            <slot />
        </div>
        <footer v-if="withFooter" class="step__footer">
            <span class="step__powered">Powered by</span>
            <BreezyLogo />
        </footer>
    </section>
</template>

<style scoped>
.step {
    --step-padding-sides: 24px;

    /* Lets the footer follow the container corners without overflow: hidden, which would cut dropdowns */
    border-radius: inherit;

    @media screen and (max-width: 767px) {
        --step-padding-sides: 16px;

        display: flex;
        flex-direction: column;
        /* Set by the popup container to make the step a full-height bottom sheet */
        min-height: var(--step-min-height, auto);
    }
}

.step__header {
    padding: 32px var(--step-padding-sides) 0;
    user-select: none;

    @media screen and (max-width: 767px) {
        padding-top: 36px;
    }
}

.step__content {
    flex: 1 1 auto;
    padding: 16px var(--step-padding-sides);
}

.step__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 0;
    background: #f4f6f8;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    user-select: none;
}

.step__powered {
    font-size: calc(var(--custom-font-size) * 0.714);
    line-height: 1;
    color: #000;
}
</style>
